<template lang="pug">
  server-data(
    v-if="$user && $user.isMember"
    v-model="userDuplicates"
    :key="$user && $user.data && $user.data.id"
    :method="getUserDuplicates"
    :serialize-data="resp => resp.items"
    start-loading-value
    @data:init="onUserDuplicateInit"
    v-slot="{ loading }"
  )
    portal(
      v-if="!loading && userDuplicates.length && dialogId"
      :to="`${dialogId}.content`"
      v-slot="{ close }"
    )
      .ui-design.d-flex.flex-column.gap-20.justify-center.align-center.mt-8.relative
        dv-btn.absolute.right-0.top-0(
          icon
          x-small
          color="ui-neutral"
          @click="close"
        ): v-icon(:size="20") $ui-close
        dv-icon(
          icon="$ui-search"
          :size="32"
          color="ui-primary"
          :sheet-props="{ size: 64, class: 'ui-primary lighten-4' }"
        )
        p.ui-h3-large.mt-2 Найдены похожие пользователей системы
        p.ui-body-1.text-center
          | Мы нашли аккаунты, которые могут принаблежать вам. #[br]
          | Перейдите на страницу дубликатов, чтобы посмотреть найденные профили
          | и при необходимости объединить их.
        dv-btn.mt-4(
          x-large
          block
          :to="{ name: 'my-profile-duplicates' }"
          @click="close"
        ) Перейти к объединению
        dv-btn(
          text
          block
          @click="onHideNextTime(); close()"
        ) Не показывать больше

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { USER_DUPLICATE_STATUS_KEY } from './constants';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import DvIcon from '@/packages/ui/components/icons/DvIcon.vue';
import { PER_PAGE } from '@/constants/pagination';

const HIDE_FOR_ROUTES = ['auth-redirect-vk', 'auth-redirect-apple', 'auth-redirect-telegram', 'auth-redirect-yandex', 'my-profile-duplicates'];

export default {
  components: {
    DvIcon,
    DvBtn,
  },
  data() {
    return {
      userDuplicates: [],
      dialogId: undefined,
    };
  },
  computed: {
    ...mapGetters({
      hideUserDuplicateDialogFor: 'auth/getHideUserDuplicateDialogFor',
    }),
    isHideByUser() {
      return !!this.hideUserDuplicateDialogFor.includes(this.$user?.data?.id);
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      hideUserDuplicateDialogForUser: 'auth/hideUserDuplicateDialogForUser',
    }),
    openDialog() {
      this.dialogId = this.$dialogs.portal({
        attrs: {
          'max-width': 550,
          hideHeader: true,
          scrollable: false,
          hideActions: true,
          zIndex: 1002,
        },
      });
    },
    async getUserDuplicates() {
      const params = {
        'search[users_exists]': 1,
        'search[status]': [USER_DUPLICATE_STATUS_KEY.notProceed, USER_DUPLICATE_STATUS_KEY.mergeInitiate].join(','),
        'per-page': PER_PAGE.one,
        expand: 'other_user,user_duplicate_merges',
      };
      return this.$models.users.duplicates.indexWithMerges({ params });
    },
    onUserDuplicateInit(data) {
      if (!data.length || !this.$user.isAuthenticated || HIDE_FOR_ROUTES.includes(this.$route.name) || this.isHideByUser) {
        return;
      }

      this.openDialog();
    },
    onHideNextTime() {
      this.hideUserDuplicateDialogForUser(this.$user.data.id);
    },
  },
};
</script>
